<template>
  <div class="card modal-card is-min-width-700">
    <div class="modal-card-body pd-0 overflow-hidden">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('ajoutEditContrat.echeancier.popUpInformationCommentaire.title') }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <b-field
          :label="$t('ajoutEditContrat.echeancier.popUpInformationCommentaire.commentaireEcheance')"
                 custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ echeance.commentaire }}
            </span>
        </b-field>
        <div class="center">
          <div class="columns is-gapless">
            <div class="column mgt-20px">
              <h2 class="title is-size-6">
       {{$t('ajoutEditContrat.echeancier.popUpInformationCommentaire.commentairesReplanification')}}
              </h2>
            </div>
          </div>
        </div>
        <v-client-table :data=echeance.commentaires :columns="columns" :options="options"
                        ref="tableCommentaire">
          <div slot="user" slot-scope="props">
            {{ getUser(props.row.creatorUserId) }}
          </div>
          <div slot="date" slot-scope="props">
            {{ props.row.creationTime | formatDate }}
          </div>
        </v-client-table>
        <div class="is-pulled-left boutonAction mgb-20px">
          <a class="button is-annuler btn-modal-annuler" @click="$parent.close()">
            {{ $t('ajoutEditContrat.echeancier.popUpInformationCommentaire.actions.close') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import formatDate from '@/services/general/formatDate';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'p_informationCommentaires',
  props: {
    echeance: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getDate(date) {
      return formatDate(date);
    },
    getUser(userId) {
      const userFound = this.parametre(PARAMETRES_KEYS.utilisateur)
        .find((user) => { return user.id === userId; });
      if (!userFound) return 'support@quadra-diffusion.fr';
      return nomPrenomGetter(userFound);
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          user: this.$t('ajoutEditContrat.echeancier.popUpInformationCommentaire.tab.user'),
          date: this.$t('ajoutEditContrat.echeancier.popUpInformationCommentaire.tab.date'),
          commentaire: this.$t('ajoutEditContrat.echeancier.popUpInformationCommentaire.tab.commentaire'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        texts: texts,
        sortable: ['user', 'date', 'commentaire'],
      };
    },
    columns() {
      return ['user', 'date', 'commentaire'];
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
